import React from 'react';
import {inject, observer} from 'mobx-react';

import './css/';
import E8Header from './E8Header';
import E8LeftMenu from './E8LeftMenu';

@inject('portalThemeStore')
@observer
class E8Theme extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {portalThemeStore, location} = this.props;
        const {pathname, query} = location;
        portalThemeStore.getTopMenu(pathname, query);
    }

    render() {
        const {portalThemeStore, location} = this.props;
        const {searchParams, themeInfo} = portalThemeStore;
        const {themeData = {}} = themeInfo;
        const {cssfile = 'left'} = themeData;
        const {query} = location;
        const {hideHeader = query.hideHeader, hideAside = query.hideAside} = searchParams;

        return (
            <div className={`e8theme-layout-container e8theme-color-${cssfile}`}>
                {
                    hideHeader == 'true' ? null : (
                        <div className="e8theme-layout-header">
                            <E8Header {...this.props} />
                        </div>
                    )
                }
                <div className="e8theme-layout-content" style={hideHeader == 'true' ? {top: 0} : {}}>
                    <div id="themeLayoutMask" className="e8theme-layout-mask"></div>
                    {
                        hideAside == 'true' ? null : (
                            <div className="e8theme-layout-aside">
                                <E8LeftMenu {...this.props} />
                            </div>
                        )
                    }
                    <div className="e8theme-layout-main" style={hideHeader == 'true' && hideAside == 'true' ? {padding: 0} : {}}>
                        <div id="themeLayoutRoute" className="e8theme-layout-route">
                            {this.props.children}
                        </div>
                        <div id="themeLayoutFrame" className="e8theme-layout-frame">
                            <iframe id="mainFrame" name="mainFrame" src="about:blank"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default E8Theme;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/index.js